module.exports = __webpack_public_path__ + "img/dimfer.d66ccf9f.png";